module.exports = __webpack_public_path__ + "img/interify_xs.f3364010.svg";